import {IS_DEV_ENV} from "../config";

/**
 * hardcoded Pardot field values
 */
export const WEB_TRACKING_CAMPAIGN_ID = IS_DEV_ENV ? 182090 : 3587;
export const CONTACT_US_CAMPAIGN_ID = IS_DEV_ENV ? 182090 : 3615;
export const FMU_CAMPAIGN_ID = IS_DEV_ENV ? 182090 : 3715;
export const ERROR_CAMPAIGN_ID = IS_DEV_ENV ? 182090 : 14332;

export const SIGNUP_INQUIRY_OBJECT = "WEB-flexport.com-sign-up";
export const FMU_INQUIRY_OBJECT = "SUBM-Weekly Market Update";
export const UNKNOWN_LP_INQUIRY_OBJECT = "Unknown - Contentful LP";
export const ERROR_INQUIRY_OBJECT = "ERROR-contentful-garbage-collection";
export const CONTACT_US_INQUIRY_OBJECT = "WEB-contact-us-form";

/**
 * some of the Pardot field names that are been used by the upstream onboarding form
 * these fields are setup through Contentful, however we need access them to perform validation and so on
 */
export const EIN_NUMBER = "EIN_Number";
